/* tslint:disable */
/* eslint-disable */
/**
 * Apperta Physical Health REST API
 * Apperta Physical Health REST API
 *
 * The version of the OpenAPI document: 0.2.0-SNAPSHOT2
 * Contact: info@staircase13.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HospitalSiteDto } from './HospitalSiteDto';
import {
    HospitalSiteDtoFromJSON,
    HospitalSiteDtoFromJSONTyped,
    HospitalSiteDtoToJSON,
} from './HospitalSiteDto';

/**
 * Returns hospital site search results 
 * @export
 * @interface HospitalSiteSearchResponse
 */
export interface HospitalSiteSearchResponse {
    /**
     * Search terms which produced results
     * @type {{ [key: string]: string; }}
     * @memberof HospitalSiteSearchResponse
     */
    searchTerms?: { [key: string]: string; };
    /**
     * Paging page size
     * @type {number}
     * @memberof HospitalSiteSearchResponse
     */
    pageSize?: number;
    /**
     * Paging start record
     * @type {number}
     * @memberof HospitalSiteSearchResponse
     */
    start?: number;
    /**
     * Total number of patient profiles
     * @type {number}
     * @memberof HospitalSiteSearchResponse
     */
    total?: number;
    /**
     * Ordered by
     * @type {string}
     * @memberof HospitalSiteSearchResponse
     */
    orderTerm?: string;
    /**
     * Order direction
     * @type {string}
     * @memberof HospitalSiteSearchResponse
     */
    orderDirection?: string;
    /**
     * List of hospital sites
     * @type {Array<HospitalSiteDto>}
     * @memberof HospitalSiteSearchResponse
     */
    sites?: Array<HospitalSiteDto>;
}

/**
 * Check if a given object implements the HospitalSiteSearchResponse interface.
 */
export function instanceOfHospitalSiteSearchResponse(value: object): value is HospitalSiteSearchResponse {
    return true;
}

export function HospitalSiteSearchResponseFromJSON(json: any): HospitalSiteSearchResponse {
    return HospitalSiteSearchResponseFromJSONTyped(json, false);
}

export function HospitalSiteSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HospitalSiteSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'searchTerms': json['searchTerms'] == null ? undefined : json['searchTerms'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'start': json['start'] == null ? undefined : json['start'],
        'total': json['total'] == null ? undefined : json['total'],
        'orderTerm': json['orderTerm'] == null ? undefined : json['orderTerm'],
        'orderDirection': json['orderDirection'] == null ? undefined : json['orderDirection'],
        'sites': json['sites'] == null ? undefined : ((json['sites'] as Array<any>).map(HospitalSiteDtoFromJSON)),
    };
}

export function HospitalSiteSearchResponseToJSON(value?: HospitalSiteSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'searchTerms': value['searchTerms'],
        'pageSize': value['pageSize'],
        'start': value['start'],
        'total': value['total'],
        'orderTerm': value['orderTerm'],
        'orderDirection': value['orderDirection'],
        'sites': value['sites'] == null ? undefined : ((value['sites'] as Array<any>).map(HospitalSiteDtoToJSON)),
    };
}

